import { Item } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { A3innuvaTariffGroupCodeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { translate } from 'modules/contracts/lib/translate'
import { cotizationGroupsToOptions } from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'

interface Props {
  form: Form
  cotizationsGroups: A3innuvaTariffGroupCodeFragment[]
  translations: { [key: string]: string }
  loading: boolean
}

const CotizationGroup = ({ form, cotizationsGroups, translations, loading }: Props) => {
  const options = cotizationGroupsToOptions(cotizationsGroups)
  const selectedValue = String(form.get('es_cotization_group').value)
  const cotizationGroupName = options.find((option) => option.value === selectedValue)?.label

  const onTariffGroupChanged = (code: Item) => {
    form.setValues({
      es_cotization_group: code.value === '' ? null : Number(code.value),
    })
  }

  const labelNotFound = () => {
    return options.length
      ? i18n.t('contract_versions.forms.contract_extra_information.a3innuva.tariff_group_not_found')
      : i18n.t('contract_versions.forms.contract_extra_information.a3innuva.label_not_found')
  }

  return (
    <DropdownSearchBar
      name={cotizationGroupName || `-- ${i18n.t('common.none')} --`}
      label={translate(translations, 'cotization_group') || ''}
      onSelect={onTariffGroupChanged}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      loading={loading}
      popoverWidth="s400"
    />
  )
}

export default observer(CotizationGroup)
